module.exports = __webpack_public_path__ + "slide3-package-ie11.52d415c482936877efbf8230f8f8d21a.hashedasset.svg";